/* eslint sort-keys-fix/sort-keys-fix: ["error", "asc", {natural: false}] */
const strings: { [key in string]: string } = {
  ACCOUNT: 'Account',
  ACCOUNTING_AND_AUDITING: 'Accounting & Auditing',
  ACCOUNT_ALREADY_EXISTS: 'Account already exists',
  ACCOUNT_DETAILS: 'Account details',
  ACCOUNT_INFORMATION_ERROR:
    'We had a temporary problem finding your information, please try again later.',
  ACCOUNT_NOT_FOUND: 'Account not found',
  ACCOUNT_NUMBER: 'Account number',
  ACCOUNT_NUMBER_COPIED: 'Account number copied successfully',
  ACCOUNT_NUMBER_DETAILS: 'Account number',
  ACCOUNT_NUMBER_WITH_CURRENCY: 'Account number ({0})',
  ACCOUNT_TYPE: 'Account type',
  ACH: 'ACH',
  ACTION_REQUIRED: 'Action required',
  ACTIVE: 'Active',
  ACTIVITY: 'Activity',
  ADD: 'Add',
  ADDRESS: 'Address',
  ADDRESS_COMPLEMENT: 'Address complement',
  ADD_CONTACT: 'Add contact',
  ADD_CONTACT_FLOW_MODAL_CURRENCY_DESCRIPTION: 'Currency: {0}',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_ACH: 'ACH or Wire',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_COP: 'ACH Colombia',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_CVU: 'Bank transfer (CVU or CBU)',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_PIX: 'Pix',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SPEI: 'Spei',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_SWIFT: 'Swift',
  ADD_CONTACT_FLOW_MODAL_PAYMENT_METHOD_WIRE: 'ACH or Wire',
  ADD_DIGITAL_DOLLARS: 'Add Digital dollars',
  ADD_DOCUMENTS: 'Add documents',
  ADD_NEW: 'Add new',
  ADD_NEW_CONTACT_WHICH_TYPE: 'What type of contact would you like to add?',
  ADD_NEW_CUSTOMER: 'Add new customer',
  ADD_NEW_RECIPIENT: 'Add new recipient',
  ADD_NEW_ROLE: 'Add new role',
  ADD_NEW_USER: 'Add new user',
  ADD_NEW_WITHDRAWAL_ACCOUNT: 'Add new withdrawal account',
  ADD_PAYMENT_METHOD: 'Add payment method',
  ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE:
    'Would you like to add a payment method to an existing or new contact?',
  ADD_YOUR_BUSINESS_INFORMATION: 'Add your business information',
  ADMIN: 'Admin',
  ADMINISTRATOR: 'Administrator',
  ADMIN_DESCRIPTION:
    'Team management, transaction capabilities, view and download transaction history and activity reports',
  ALL: 'All',
  ALREADY_HAVE_ACCOUNT: 'Already have an account?',
  AMOUNT: 'Amount',
  AMOUNT_ADDED_TO_WALLET: 'Amount added to wallet',
  AMOUNT_BIGGER_THAN_BALANCE: 'Amount cannot be greater than your balance (${0})',
  AMOUNT_TO_CONVERT: 'Amount to convert',
  AND_READ_UNDERSTOOD_OUR: 'and that you have read and understood our',
  ANY: 'Any',
  AN_ERROR_OCCURRED: 'An unknown error occurred, please try again later.',
  APPEARANCE: 'Appearance',
  APPLY: 'Apply',
  APPROVED: 'Approved',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_DESCRIPTION: 'This actions not reversible.',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT_TITLE:
    'Are you sure you want to delete this account?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CONTACT_TITLE:
    'Are you sure you want to delete this contact?',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_WITHOUT_HASH:
    'Are you sure you want to leave without providing a transaction hash?',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THESE_USERS_FROM_YOUR_TEAM: `Are you sure you want to remove {0} from your team?`,
  ASSET_TYPE: 'Asset type',
  BACK: 'Back',
  BACK_TO_APPLICATION: 'Back to application',
  BACK_TO_DASHBOARD: 'Back to dashboard',
  BACK_TO_LOGIN: 'Back to sign in',
  BALANCE: 'Balance',
  BANK: 'Bank',
  BANK_ACCOUNT: 'Bank account',
  BANK_ACCOUNT_INFORMATION: 'Bank account information',
  BANK_ACCOUNT_NUMBER: 'Bank account number',
  BANK_ACCOUNT_TYPE: 'Bank account type',
  BANK_CODE: 'Bank code',
  BANK_INFORMATION: 'Bank information',
  BANK_NAME: 'Bank name',
  BENEFICIARY_NAME: 'Beneficiary name',
  BENEFICIARY_OR_RECIPIENT_CONTACT: 'Beneficiary or recipient contact',
  BRAZILIAN_PIX: 'Brazilian real (Pix)',
  BRL_MARKET_HOURS_ALERT:
    'This operation can only be completed during business hours: Monday to Friday, 9:00 AM – 3:40 PM BRT (excluding holidays).',
  BUSINESS: 'Business',
  BUSINESS_EMAIL: 'Business email',
  BUSINESS_INFORMATION: 'Business information',
  BUSINESS_NAME: 'Business name',
  BUSINESS_RELATIONSHIP: 'Business relationship',
  BY_CONFIRMING_EMAIL_AGREE: 'By confirming your email, you agree to our',
  CALIZA_ACCOUNT: 'Caliza account ({0})',
  CALIZA_DOES_NOT_CHARGE_DEPOSIT_FEES:
    'Caliza does not charge any deposit fees. However, your external wallet may charge fees to transfer funds.',
  CALIZA_TERMS_AND_SERVICES: "Caliza's Terms and Services",
  CALIZA_WALLET: 'Caliza wallet',
  CALIZA_WALLET_BALANCE: 'Caliza wallet balance',
  CANCEL: 'Cancel',
  CANCEL_TRANSFER: 'Cancel transfer',
  CANT_SCAN_THE_CODE: "Can't scan the code?",
  CHAIN: 'Chain',
  CHAIN_ETHEREUM: 'Ethereum',
  CHAIN_POLYGON: 'Polygon',
  CHAIN_TRON: 'TRON',
  CHAIN_UNKNOWN: 'Unknown',
  CHANGE_PASSWORD_DESCRIPTION: 'Confirmation when your password is changed',
  CHANGE_PASSWORD_LABEL: 'Change password',
  CHECKING: 'Checking',
  CHECK_EMAIL_FOR_CODE: 'Please check {0} to retrieve your one-time passcode',
  CHECK_HISTORY_DESCRIPTION:
    'Check your history to track the status of the transfer. Transaction details can take a few minutes before they appear.',
  CHECK_YOUR_PAYMENT_HISTORY_TO_TRACK_STATUS:
    'Check your payment history to track the status of the payment.',
  CHOOSE_DEPOSIT_AMOUNT: 'Choose deposit amount',
  CITY: 'City',
  CLOSE: 'Close',
  CODE_EXPIRED: 'Code has expired. Please request a new one',
  CODE_RESENT: 'Code resent',
  COMMA_AND_ONE: ', and one',
  COMMA_ONE: ', one',
  COMPANY: 'Company',
  COMPLETED: 'Completed',
  COMPLETED_DESCRIPTION:
    'Get notified when a transfer is complete and the recipient has received their funds',
  COMPLETED_LABEL: 'Complete',
  COMPLETED_STATUS: 'Completed',
  CONFIRM_NEW_PASSWORD: 'Confirm new password',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PAYMENT: 'Confirm payment',
  CONFIRM_WITHDRAWAL: 'Confirm withdrawal',
  CONTACT: 'Contact',
  CONTACTS: 'Contacts',
  CONTACT_DETAILS: 'Contact details',
  CONTACT_NICKNAME: 'Contact nickname',
  CONTACT_TYPE: 'Contact type',
  CONTINUE: 'Continue',
  CONTINUE_WITH_GOOGLE: 'Continue with Google',
  CONVERSION_QUOTE: 'Conversion quote',
  CONVERSION_RATE: 'Conversion rate',
  CONVERSION_RATE_TOOLTIP: 'Conversion rate includes {0} FX spread',
  CONVERT: 'Convert',
  CONVERTED_CURRENCY: 'Converted currency',
  CONVERT_ACCOUNT_BALANCE: 'Convert account balance',
  CONVERT_SUCCESS: 'Conversion completed successfully',
  COPY_CLABE: 'Copy CLABE',
  COPY_LINK: 'Copy link',
  COUNTRY: 'Country',
  COUNTRY_OF_RESIDENCE: 'Country of residence',
  COUNT_OF_COUNT_COMPLETE: '{0} of {1} complete',
  CO_CC_LABEL: 'Cédula de Ciudadanía',
  CO_CE_LABEL: 'Cédula de Extranjería',
  CO_NIT_LABEL: 'Número de Identificación Tributaria',
  CO_SPECIAL_RESIDENCE_PERMIT: 'Permiso Especial de Permanencia',
  CREATED: 'Created',
  CREATED_DESC: 'Your transaction was created.',
  CREATE_A_CALIZA_ACCOUNT: 'Create a\nCaliza account',
  CREATE_CUSTOM_ROLE_NAME: 'Create a name for this custom role:',
  CREATE_INTEGRATOR_SUCCESS: 'Integrator created successfully',
  CREATE_TRANSACTIONS: 'Create transactions',
  CREATE_USER_FAILED: 'An error occurred while creating user',
  CREATE_USER_SUCCESS: 'User created successfully',
  CROSS_BORDER_SUPPLY_CHAIN: 'Cross-Border Supply Chain',
  CROSS_BORDER_SUPPLY_CHAIN_DESC: 'Simplify international accounts payable & accounts receivable',
  CRYPTO_DEPOSIT_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_DEPOSIT_COMPLETED_TITLE: 'Once we receive your funds, we will complete your deposit',
  CRYPTO_HASH_TRANSFER_MODAL_DESCRIPTION:
    'The transaction hash to automatically reconcile your incoming deposit.',
  CRYPTO_HASH_TRANSFER_MODAL_TITLE: 'Share the transaction hash provided by your external wallet',
  CRYPTO_TRANSFER_COMPLETED_DESCRIPTION:
    'Check your activity to track the status of the transfer. Transaction details can take a few minutes before they appear. ',
  CRYPTO_TRANSFER_COMPLETED_TITLE: 'Once we receive your funds, we will complete your transfer',
  CRYPTO_TRANSFER_MODAL_DESCRIPTION:
    'Copy the transaction hash from your wallet or exchange and paste it here so we can verify your deposit. Once confirmed, your transfer will be completed and shown in your transaction history.',
  CRYPTO_TRANSFER_MODAL_TITLE: 'Share transaction hash to complete your operation',
  CURRENCY_CONVERT_TO_DIGITAL_DOLLARS:
    '{0} will automatically convert to digital dollars once we receive your deposit.',
  CURRENCY_TYPE: 'Currency type',
  CURRENCY_TYPE_LABEL: 'Currency type',
  CURRENT_PASSWORD: 'Current password',
  CUSTOM: 'Custom',
  CUSTOMERS: 'Customers',
  CUSTOMER_SUCCESS: 'Customer Success',
  CUSTOMER_TYPE: 'Customer type',
  CUSTOMER_VERIFICATION_CREATE_ERROR: 'Failed to create customer verification',
  CUSTOMER_VERIFICATION_ERROR: 'An error occurred during verification',
  CUSTOMER_VERIFICATION_INFO: 'Please finish set up for verification to continue transfers',
  CUSTOMER_VERIFICATION_STARTED_SUCCESS:
    'Pending customer verification saved. It can be safely abandoned and resumed later if needed.',
  CUSTOMER_VERIFICATION_SUCCESS: 'Verification completed successfully',
  CVU: 'CVU',
  CVU_OR_CBU: 'CVU or CBU',
  DARK: 'Dark',
  DATE: 'Date',
  DATE_AND_TIME: 'Date and time',
  DAY: 'Day',
  DEACTIVATE_ACCOUNT: 'Deactivate account',
  DECLINED: 'Declined',
  DELETE_ACCOUNT: 'Delete account',
  DELETE_CONTACT: 'Delete contact',
  DELETE_CONTACT_SUCCESS: 'Contact deleted successfully',
  DELETE_PAYMENT_METHOD_SUCCESS: 'Payment method deleted successfully',
  DEPARTMENT: 'Department',
  DEPOSIT: 'Deposit',
  DEPOSIT_COMPLETED: 'Deposit Completed',
  DEPOSIT_COMPLETED_DESC: 'Your deposit has been completed.',
  DEPOSIT_COMPLETED_TITLE: 'Your funds have been added',
  DEPOSIT_FIAT_ACCOUNT_MODAL_DESCRIPTION:
    'Once we receive your funds from your bank, we will automatically send your transfer and confirm via email and your transaction history.',
  DEPOSIT_FIAT_ACCOUNT_MODAL_TITLE: 'Send funds from your bank to complete transfer',
  DEPOSIT_FROM: 'Deposit from {0}',
  DEPOSIT_PENDING_TITLE: 'We are depositing your funds',
  DEPOSIT_RECEIVED: 'Deposit Received',
  DEPOSIT_RECEIVED_DESC: 'Your deposit has been received.',
  DESCRIPTION_OF_ROLE_OPTIONAL: 'Description of Role (Optional)',
  DESELECT_ALL: 'Deselect all',
  DESTINATION_COUNTRY: `Country of recipient's account`,
  DETAILS: 'Details',
  DEVICE_NAME: 'Device name',
  DEVICE_NAME_HELP: 'Optional: Give this device a name for easy identification',
  DEVICE_NAME_PLACEHOLDER: 'My Phone',
  DIGITAL_DOLLAR: 'Digital dollar',
  DISABLE: 'Disable',
  DISABLE_TWO_FACTOR_AUTHENTICATION_TITLE: 'Are you sure you want to disable 2FA?',
  DISABLING: 'Disabling...',
  DOCUMENT_WITH_NAME_TEMPLATE: 'Document {0}',
  DONE: 'Done',
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  DONT_SUPPORT_COUNTRY: "We don't support your country yet",
  DOWNLOAD_COMPROVANTE_OPERACAO_TRANSACTION_DOCUMENT:
    'Comprovante de operação de pagamento internacional',
  DOWNLOAD_PAYMENT_CONFIRMATION_TRANSACTION_DOCUMENT: 'Transaction confirmation',
  DOWNLOAD_STATEMENT: 'Download statement',
  DOWNLOAD_TRANSACTION_DOCUMENTS: 'Download transaction documents',
  EDIT: 'Edit',
  EDIT_RECIPIENT_TABS: 'Edit recipient tabs',
  EIGHT_CHARACTERS: 'eight characters',
  EMAIL: 'Email',
  EMAIL_INVALID_FORMAT: 'Email format is not valid',
  ENABLE: 'Enable',
  ENABLING: 'Enabling...',
  ENTER_TOTP_CODE: 'Enter code',
  ENTER_VERIFICATION_CODE: 'Enter verification code',
  ENTER_VERIFICATION_CODE_DESCRIPTION:
    'Enter the 6-digit code from your authenticator app to complete setup',
  ERROR_DISPLAYING_ROW_DATA: 'Error displaying row data',
  ERROR_LOADING_CUSTOMER: 'Error loading customer details',
  ERROR_LOADING_PREFERENCES: 'Error loading preferences',
  EXCHANGE: 'Exchange',
  EXCHANGE_COMPLETED: 'Exchange completed',
  EXISTING_CONTACT: 'Existing contact',
  EXPIRED: 'Expired',
  EXPIRED_DESC: 'This transaction has expired',
  EXTERNAL_ACCOUNT: 'External',
  EXTERNAL_ACCOUNT_ACH: 'External',
  EXTERNAL_ACCOUNT_PIX: 'External: Pix',
  EXTERNAL_ACCOUNT_SWIFT: 'External: Swift',
  EXTERNAL_ACCOUNT_WIRE: 'External: Wire',
  EXTERNAL_PAYMENT_REFERENCE_OPTIONAL: 'External payment reference (Optional)',
  EXTERNAL_RECIPIENT: 'External recipient',
  FAILED: 'Failed',
  FAILED_DESC: 'Your payment has failed',
  FAILED_DESCRIPTION: 'Get notified when a transfer has failed',
  FAILED_LABEL: 'Failed',
  FAILED_TO_LOAD_TRANSACTION_STATUS: 'Failed to load transaction status',
  FEATURE_NOT_AVAILABLE_DESCRIPTION:
    'We apologize for the inconvenience. This feature exists but is temporarily disabled. Please check back later for updates.',
  FEATURE_NOT_AVAILABLE_TITLE: 'Feature currently unavailable',
  FEE: 'Fee',
  FEES: 'Fees',
  FIAT_ACCOUNT_ACH: 'Bank Account (ACH)',
  FIAT_ACCOUNT_COP: 'COP',
  FIAT_ACCOUNT_CVU: 'Bank transfer (CVU or CBU)',
  FIAT_ACCOUNT_PIX: 'Pix',
  FIAT_ACCOUNT_SPEI: 'SPEI',
  FIAT_ACCOUNT_SWIFT: 'Bank Account (SWIFT)',
  FIAT_ACCOUNT_WIRE: 'Bank Account (Wire)',
  FILE_NAME_AND_SIZE_TEMPLATE: 'File name {0} - {1}',
  FILL_ALL_ENTRIES_AND_SUBMIT: 'Fill all entries and submit',
  FILL_OUT_DETAILS_FOR_NEW_MEMBER:
    'Fill out details for your new team member and they will receive an email shortly after sending an invite.',
  FILTER: 'Filter',
  FILTER_WITH_COUNT: 'Filter ({0})',
  FINANCE_AND_TREASURY: 'Finance & Treasury',
  FIRST_NAME: 'First name',
  FOUR_STEPS_BEFORE_FIRST_PAYMENT: 'Four steps before your first payment',
  FROM: 'From',
  FROM_DATE: 'From ({0})',
  FUNCTIONALITIES: 'Functionalities',
  FUNDING_METHOD: 'Funding method',
  FUNDING_WITH: 'Funding with {0}',
  FX_RATE: 'Rate',
  GET_HELP: 'Get help',
  GLOBAL_BUSINESS_ACCOUNTS: 'Global Business Accounts in Digital Dollars',
  GLOBAL_MERCHANT_SETTLEMENT: 'Global Merchant Settlement',
  GLOBAL_MERCHANT_SETTLEMENT_DESC: 'Instant payouts for marketplaces, e-commerce and platforms',
  GROSS_AMOUNT: 'Gross amount',
  HELP: 'Help',
  HIDE_ROLE_DETAILS: 'Hide role details',
  HOME: 'Home',
  HOUR: 'hour',
  HOURS: 'hours',
  IBAN: 'IBAN',
  IBAN_ACCOUNT_NUMBER: 'IBAN / Account number',
  IBAN_DETAILS: 'IBAN',
  IBAN_VALIDATION_INVALID_ACCOUNT_NUMBER: 'Invalid Account Number',
  IBAN_VALIDATION_INVALID_COUNTRY: 'Invalid IBAN of country {0}, for country {1}',
  IBAN_VALIDATION_INVALID_FORMAT: 'Invalid IBAN format',
  IBAN_VALIDATION_INVALID_IBAN: 'Invalid IBAN',
  IBAN_VALIDATION_TOO_SHORT_4: 'Must be large than 4 characters',
  'ID_#': 'ID #',
  INCOMPLETE_STATUS: 'Incomplete',
  INCORRECT_CODE: 'Incorrect code. Please try again',
  INCORRECT_EMAIL_PASSWORD: 'Incorrect email or password',
  INDIVIDUAL: 'Individual',
  INFORMATION_FOR_PAYMENT_BENEFICIARY_OR_RECIPIENT:
    'Information for payment beneficiary or recipient',
  INITIATED_BY: 'Initiated by',
  INSTALL_AUTHENTICATOR_APP: 'Install an authenticator app',
  INSTALL_AUTHENTICATOR_APP_DESCRIPTION: 'Download and install an authenticator app such as {0}',
  INSTANT_GLOBAL_PAYMENTS: 'Instant Global Payments',
  INSUFFICIENT_FUNDS: 'Insufficient funds',
  INTERNAL_NOTES_DESCRIPTION:
    'You can view attachments and notes in your activity for future reference. This is for your eyes only.',
  INTERNAL_NOTES_OPTIONAL: 'Internal notes (Optional)',
  INTERNAL_TRANSFER_COMPLETED: 'Internal transfer completed',
  INTERNAL_TRANSFER_NOTES: 'Internal transfer notes or memo',
  INTERNATIONAL_PAYROLL: 'International Payroll',
  INTERNATIONAL_PAYROLL_DESC: 'Pay your international workforce in digital dollars',
  INVALID_OTP: 'Invalid code. Please try again.',
  INVALID_SWIFT_CODE_FOR_IBAN: 'Swift code does not match IBAN',
  INVITATION_SENT: 'Invitation sent',
  INVITE: 'Invite',
  INVITE_A_TEAM_MEMBER: 'Invite a team member',
  INVOICES_RECEIPTS_ETC: '(Invoices, receipts, etc)',
  IN_PROGRESS: 'In progress',
  IOF_WITH_PERCENTAGE: `IOF ({0})`,
  IS_POBO: 'I am instructing this payment on my client’s behalf',
  I_AGREE_TO_THE:
    'I hereby declare that the information I am providing is truthful and accurate to the best of my knowledge and have read and agree to ',
  JOIN_YOUR_TEAM_ON_CALIZA: 'Join your team on Caliza',
  KEEP_ACCOUNT: 'Keep account',
  KEEP_CONTACT: 'Keep contact',
  KEEP_TWO_FACTOR_AUTHENTICATION_ENABLED: 'Keep 2FA',
  LABEL_OR_TITLE: 'label',
  LANGUAGE: 'Language',
  LAST_NAME: 'Last name',
  LEADERSHIP_EXECUTIVE: 'Leadership / Executive',
  LEAVE_ANYWAY: 'Leave anyway',
  LEAVE_WITHOUT_HASH_DESC: 'Operations without a transaction hash take longer to complete.',
  LEGAL: 'Legal',
  LEGAL_ENTITY_NAME: 'Legal entity name',
  LIGHT: 'Light',
  LINK_ACCOUNT: 'Link {0} to existing account',
  LINK_COPIED: 'Link copied successfully',
  LOADING_PLEASE_WAIT: 'Loading, please wait',
  LOADING_TRANSACTION_STATUS: 'Loading transaction status',
  LOGIN_AND_SECURITY: 'Login & security',
  LOG_IN: 'Log in',
  MAKE_A_TRANSFER: 'Make a transfer',
  MANAGE_PAYMENT_CONTACTS: 'Manage payment contacts',
  MANAGE_PAYOUTS: 'Manage payouts or receive funds instantly in stablecoins',
  MANAGE_ROLES: 'Manage roles',
  MANAGE_TEAM_AND_USERS: 'Manage team and users',
  MANAGE_USER: 'Manage user',
  MANAGE_USERS: 'Manage users',
  MANUAL_ENTRY_OPTION: 'Or enter this key manually in your authenticator app:',
  MAX: 'Max',
  MEMO_OR_DESTINATION_OPTIONAL: 'Memo or Destination Tag (Optional)',
  METHOD: 'Method',
  MEXICAN_SPEI: 'Mexican pesos (SPEI)',
  MID_MARKET_RATE: 'Mid-market rate',
  MINUTES: 'minutes',
  MISSING_INTEGRATOR_INFORMATION: 'Missing integrator information, please complete KYB',
  MONTH: 'Month',
  MORE: '+{0} more',
  NAME: 'Name',
  NEW_CONTACT: 'New contact',
  NEW_DEVICE_LOGIN_DESCRIPTION: 'Sign ins from a new device',
  NEW_DEVICE_LOGIN_LABEL: 'New device login',
  NEW_PASSWORD: 'New password',
  NEXT: 'Next',
  NICKNAME: 'Nickname',
  NICKNAME_REQUIRED_ERROR: 'Nickname cannot be empty',
  NINE_MIN: '9 min',
  NO: 'No',
  NOTIFICATIONS: 'Notifications',
  NOT_APPLICABLE: 'N/A',
  NOT_STARTED: 'Not started',
  NO_ACCOUNTS: 'No accounts',
  NO_ACTIVITY_YET_SUBTITLE: 'Send or receive funds and they will appear here.',
  NO_ACTIVITY_YET_TITLE: 'No activity yet',
  NO_CUSTOMERS_YET_TITLE: 'No customers added yet',
  NO_ILL_WAIT: "No, I'll wait",
  NO_ITEMS_FOUND: 'No items found',
  NO_NUMBER: 'Password must have at least 1 number',
  NO_RECIPIENT_ACCOUNTS: 'No recipient accounts',
  NO_SPECIAL_CHARACTER: 'Password must have at least 1 special character',
  NUMBER: 'number',
  ONE_TIME_PASSWORD: 'Verify with two-factor authentication',
  ONE_TIME_PASSWORD_DESCRIPTION: 'Enter the temporary code generated in your authenticator app',
  ONLY_CURRENCY_SUPPORTED_BY_COUNTRY: 'Only {0} are supported by this country.',
  ONLY_FOR_DOMESTIC_ACH_AND_WIRES: '(For domestic ACH & Wire only)',
  OPERATIONS: 'Operations',
  OPERATIONS_WITHOUT_A_TRANSACTION_HASH_TAKE_LONGER:
    'Operations without a transaction hash take longer to complete.',
  OPERATOR: 'Operator',
  OPERATOR_DESCRIPTION:
    'Transaction capabilities, view and download transaction history and activity reports',
  OTHER: 'Other',
  PASSPORT: 'Passport',
  PASSWORD: 'Password',
  PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
  PASSWORD_IS_EMPTY_ERROR: 'Password cannot be empty',
  PASSWORD_MINIMUM: 'Password must have a minimum of',
  PAYMENT_BENEFICIARY_INFO: 'Information for payment beneficiary or recipient',
  PAYMENT_COMPLETED: 'Payment completed',
  PAYMENT_COMPLETED_DESC: 'Your payment has been completed.',
  PAYMENT_METHOD: 'Payment method',
  PAYMENT_METHODS: 'Payment methods',
  PAYMENT_RAIL_FEE: '{0} fee',
  PAYMENT_REFERENCE: 'Payment reference ({0} characters max)',
  PAYMENT_REFERENCE_DESCRIPTION:
    'This is an optional payment reference for your recipient to see and verify your transfer.',
  PAYMENT_REFERENCE_DETAILS_LABEL: 'Payment reference',
  PAYMENT_REFERENCE_LABEL: 'Payment reference (200 character max)',
  PAYMENT_SENT: 'Payment sent',
  PAYMENT_SENT_DESC: 'Your payment has been sent.',
  PAYMENT_SENT_DESCRIPTION:
    'Get notified when a transfer is in progress, on its way to the recipient',
  PAYMENT_SENT_LABEL: 'Payment sent',
  PAYMENT_UNDER_REVIEW: 'Payment Under Review',
  PAYMENT_UNDER_REVIEW_DESC: 'Your payment is being reviewed for compliance.',
  PENDING: 'Pending',
  PENDING_DESC: 'Your payment is processing',
  PERSONAL_INFORMATION: 'Personal information',
  PIX: 'Pix',
  PIX_DEPOSIT_DESCRIPTION:
    'Once you are in your banking app, use the link below to complete your deposit using Pix. We will send you an email confirmation once your deposit is received.',
  PIX_KEY: 'PIX key',
  PREFERRED_LANGUAGE: 'Preferred language',
  PREVIEW: 'Preview',
  PRIVACY_POLICY: 'Privacy Policy',
  PROCEED_WITH_ACTION: 'Proceed with action',
  PROCESSED_BY_BANK: 'Processed by Bank',
  PROCESSED_BY_BANK_DESC: 'Your payment has been processed by the sending bank.',
  PROCESSED_BY_INTERMEDIARY_BANK: 'Processed by Intermediary Bank',
  PROCESSED_BY_INTERMEDIARY_BANK_DESC: 'Your payment has been processed by the intermediary bank.',
  PROCESSING: 'Processing',
  PROCESSING_DESC: 'Your payment is being processed.',
  PRODUCT_AND_TECHNOLOGY: 'Product & Technology',
  PROFILE: 'Profile',
  PROVIDE_THE_SIX_DIGIT_CODE: 'Provide the 6 digit code from your authenticator',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_DESCRIPTION: 'Equity, funding transfers',
  PURPOSE_OF_TRANSFER_CAPITAL_INJECTION_INVESTMENT_LABEL: 'Capital Injection / Investment',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_DESCRIPTION: 'Sales commissions, brokerage',
  PURPOSE_OF_TRANSFER_COMMISSION_AND_AGENT_FEES_LABEL: 'Commission & Agent Fees',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_DESCRIPTION: 'Between related entities',
  PURPOSE_OF_TRANSFER_INTERCOMPANY_TRANSFERS_LABEL: 'Intercompany Transfers',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_DESCRIPTION: 'Goods and services from vendors',
  PURPOSE_OF_TRANSFER_INVOICE_AND_SUPPLIER_PAYMENTS_LABEL: 'Invoice & Supplier Payments',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_DESCRIPTION: 'IP, software, patent payments',
  PURPOSE_OF_TRANSFER_LICENSING_AND_ROYALTIES_LABEL: 'Licensing & Royalties',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_DESCRIPTION: 'Business loan payments',
  PURPOSE_OF_TRANSFER_LOAN_REPAYMENT_AND_INTEREST_LABEL: 'Loan Repayment & Interest',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_DESCRIPTION: 'Freight, customs, warehousing',
  PURPOSE_OF_TRANSFER_LOGISTICS_AND_SHIPPING_LABEL: 'Logistics & Shipping',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_DESCRIPTION: 'Digital ads, campaigns, agencies',
  PURPOSE_OF_TRANSFER_MARKETING_AND_ADVERTISING_LABEL: 'Marketing & Advertising',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_DESCRIPTION: 'Rent, utilities, insurance',
  PURPOSE_OF_TRANSFER_OPERATIONAL_EXPENSES_LABEL: 'Operational Expenses',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_DESCRIPTION: 'Salaries, wages, freelancers',
  PURPOSE_OF_TRANSFER_PAYROLL_AND_CONTRACTOR_PAYMENTS_LABEL: 'Payroll & Contractor Payments',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_DESCRIPTION: 'Consulting, legal, accounting fees',
  PURPOSE_OF_TRANSFER_PROFESSIONAL_SERVICES_LABEL: 'Professional Services',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_DESCRIPTION: 'VAT, customs, regulatory',
  PURPOSE_OF_TRANSFER_TAXES_DUTIES_AND_GOVERNMENT_FEES_LABEL: 'Taxes, Duties & Government Fees',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_DESCRIPTION: 'SaaS, cloud, IT infrastructure',
  PURPOSE_OF_TRANSFER_TECHNOLOGY_SERVICES_LABEL: 'Technology Services',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_DESCRIPTION: 'Letters of credit, trade settlements',
  PURPOSE_OF_TRANSFER_TRADE_FINANCE_LABEL: 'Trade Finance',
  QR_CODE: 'QR Code',
  QR_CODE_NOT_AVAILABLE: 'QR code not available',
  QUOTE_WILL_EXPIRE: 'This quote will expire in',
  RECEIVED_BY_BENEFICIARY_BANK: 'Received by Beneficiary Bank',
  RECEIVED_BY_BENEFICIARY_BANK_DESC: 'Your payment has been received by the beneficiary bank.',
  RECEIVED_BY_INTERMEDIARY_BANK: 'Received by Intermediary Bank',
  RECEIVED_BY_INTERMEDIARY_BANK_DESC: 'Your payment has been received by the intermediary bank.',
  RECEIVE_AND_SEND_USD: 'Receive and send USD using your own account and routing number',
  RECIPIENT: 'Recipient',
  RECIPIENTS: 'Recipients',
  RECIPIENTS_WALLET: "Recipient's wallet address",
  RECIPIENT_DETAILS: 'Recipient details',
  RECIPIENT_EMAIL: 'Recipient email',
  RECIPIENT_GETS: 'Recipient gets',
  RECIPIENT_ID: 'Recipient ID',
  RECIPIENT_ID_TYPE: 'Recipient ID Type',
  RECIPIENT_INFORMATION: 'Recipient information',
  RECIPIENT_MEMO: 'Recipient memo',
  RECIPIENT_MEMO_OPTIONAL: 'Recipient memo (Optional)',
  RECIPIENT_NOT_FOUND: 'Recipient not found',
  RECIPIENT_TYPE: 'Recipient type',
  REFERENCE: 'Reference',
  REGISTRATION_NUMBER: 'Registration number',
  REMOVE: 'Remove',
  REMOVE_USERS_BUTTON_LABEL: 'Remove {0}',
  REQUIRED_ACCOUNT: 'Select account to continue',
  REQUIRED_AMOUNT: 'Amount cannot be empty',
  REQUIRED_FUNDING_METHOD: 'Select funding method to continue',
  REQUIRED_RECIPIENT: 'Recipient cannot be empty',
  REQUIRED_SUPPORTING_DOCUMENTATION: 'Supporting documentation is required',
  RESEND: 'Resend',
  RESEND_CODE: 'Resend code',
  RESEND_INVITE: 'Resend invite',
  RESEND_INVITE_ERROR: 'Error resending invitation',
  RESEND_INVITE_SUCCESS: 'Invitation resent successfully',
  RESET: 'Reset',
  RESETTING: 'Resetting...',
  RESET_PASSWORD: 'Reset password',
  RESET_PASSWORD_DESCRIPTION: 'Type in your current password to reset it',
  RESET_PASSWORD_FAILED: 'Reset password failed. Please try again.',
  RESET_PASSWORD_FORBIDDEN: 'Please provide your current password to reset it.',
  RESET_PASSWORD_SUCCESS: 'Password reset successfully',
  RESET_PASSWORD_TITLE: 'Reset password',
  RESULT: 'Result',
  RESUME_VERIFICATION: 'Resume verification',
  REVIEW: 'Review',
  REVIEW_AND_SUBMIT: 'Review and submit',
  REVIEW_CONVERSION: 'Review conversion',
  REVIEW_PROFILE: 'Review profile',
  RISK_AND_COMPLIANCE: 'Risk & Compliance',
  ROLE: 'Role',
  ROLE_CREATE_TRANSACTIONS: 'Create transactions',
  ROLE_MANAGE_CUSTOMER: 'Manage customers',
  ROLE_MANAGE_PAYMENT_CONTACTS: 'Manage payment contacts',
  ROLE_MANAGE_USER: 'Manage team and users',
  ROLE_NAME: 'Role name',
  ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS: 'Receive transaction status notifications',
  ROLE_VIEW_ACTIVITY: 'View and download transaction history and activity report',
  ROUTING_NUMBER: 'Routing number',
  ROUTING_NUMBER_COPIED: 'Routing number copied successfully',
  ROUTING_NUMBER_DETAILS: 'Routing number',
  ROUTING_NUMBER_WITH_CURRENCY: 'Routing number ({0})',
  RUNNING: 'Running',
  SALES: 'Sales',
  SAMPLE_RESPONSES: 'Sample responses',
  SAVE: 'Save',
  SAVE_AND_CLOSE: 'Save and close',
  SAVE_CHANGES: 'Save changes',
  SAVINGS: 'Savings',
  SCAN_QR_CODE: 'Scan the QR code',
  SEARCH: 'Search',
  SEARCH_BY_NAME: 'Search by name',
  SECURE_AND_COMPLIANT: 'Secure and Compliant Crypto Ramps',
  SEE_ALL: 'See all',
  SEE_DETAILS: 'See details',
  SELECT_ACCOUNT: 'Select account',
  SELECT_ALL: 'Select all',
  SELECT_CONTACT_TYPE: 'Select contact type',
  SELECT_EXISTING_CONTACT: 'Select existing contact',
  SELECT_FILTERS_THAT_APPLY: 'Select any of the following filters to apply to your search',
  SELECT_FUNDING_CURRENCY: 'Select funding currency',
  SELECT_PAYMENT_METHOD: 'Select a payment method',
  SELECT_PURPOSE_FOR_TRANSFER: 'Select purpose for transfer',
  SELECT_RECIPIENT_ACCOUNT: 'Select recipient account details',
  SELECT_RECIPIENT_ACCOUNT_DETAILS: 'Select recipient account details',
  SELECT_ROLE_FUNCTIONS: 'Select which functions this role has:',
  SELECT_TYPE: 'Select type',
  SELECT_WAYS_TO_USE_CALIZA: 'Select the ways you plan to use Caliza',
  SEND_FUNDS_FROM_BANK: 'Send funds from your bank to complete transfer',
  SEND_FUNDS_TO_CALIZA_WALLET: 'Send funds to your Caliza account',
  SEND_FUNDS_TO_COMPLETE_TRANSFER: 'Send funds to complete transfer',
  SEND_TO_RECIPIENT: 'Send to recipient',
  SETTINGS: 'Settings',
  SETTINGS_UPDATE_ERROR: 'Settings update failed. Please try again.',
  SETTINGS_UPDATE_SUCCESS: 'Settings updated successfully',
  SETTLEMENT_CURRENCY: 'Settlement currency',
  SETTLEMENT_INSTANT: 'Instant',
  SETTLEMENT_INSTANT_MARKET_HOURS: 'Instant (during market hours)',
  SETTLEMENT_ONE_TO_THREE_DAYS: '1-3 business days',
  SETTLEMENT_ONE_TO_TWO_DAYS: '1-2 business days',
  SETTLEMENT_SAME_DAY_BEFORE_CUTOFF: 'Same day (if sent before daily cutoff)',
  SETTLEMENT_TIME: 'Settlement time',
  SETTLEMENT_UNKNOWN: 'Settlement time unavailable',
  SETTLEMENT_WITHIN_15_MINUTES: 'Typically within 15 minutes',
  SETTLEMENT_WITHIN_5_MINUTES: 'Typically within 5 minutes',
  SETUP_AUTHENTICATOR: 'Set up your authenticator',
  SET_NEW_PASSWORD: 'Set new password',
  SHARE_TRANSACTION_HASH: 'Share transaction hash',
  SHOW_ROLE_DETAILS: 'Show role details',
  SIGN_IN: 'Sign in',
  SIGN_OUT: 'Sign out',
  SIGN_UP: 'Sign up',
  SIGN_UP_WITH_GOOGLE: 'Sign up with Google',
  SIX_DIGIT_AUTHENTICATOR_CODE: '6 digit authenticator code',
  SKIP_TWO_FACTOR_VERIFICATION: 'Skip two-factor verification',
  SPECIAL_CHARACTER: 'special character',
  SPEI_BANK_BENEFICIARY: 'Beneficiary',
  SPEI_BANK_NAME: 'Bank',
  SPEI_CLABE_COPIED: 'CLABE copied.',
  SPEI_DEPOSIT_DESCRIPTION: 'Use this CLABE Account to make your deposit.',
  STABLECOIN_WALLET: 'Stablecoin wallet',
  START_CURRENCY: 'Starting currency',
  START_VERIFICATION: 'Start verification',
  STATE: 'State',
  STATUS: 'Status',
  STEP: 'Step',
  STREET_ADDRESS: 'Street address',
  SUBMIT: 'Submit',
  SUBMITTED: 'Submitted',
  SUITE_FLOOR_APT: 'Suite / Floor / Apt',
  SUPPORTING_DOCUMENTATION: 'Supporting documentation',
  SUPPORTING_DOCUMENTATION_DESCRIPTION:
    'For compliance reasons, this payment requires a supporting document, such as an invoice, contract or pay slip. This will not be sent to your recipient.',
  SWIFT: 'SWIFT',
  SWIFT_CODE: 'SWIFT code',
  SWIFT_CODE_DETAILS: 'Swift code',
  SWIFT_CURRENCY_INSTRUCTED_VERSUS_SETTLEMENT_TOOLTIP: `Funds are instructed in USD. Settlement currency depends on the recipient's bank and account.`,
  SWIFT_MINIMUM_AMOUNT: 'Minimum amount for SWIFT transfer is {0}',
  TAX: `Tax ({0})`,
  TEN_MIN: '10 min',
  TERMS_ACCEPT_ERROR: 'You must accept the Terms of Service and Privacy Policy',
  TERMS_OF_SERVICE: 'Terms of Service',
  THEME: 'Theme',
  THESE_USERS: 'these users',
  THIS_ACTION_IS_NOT_REVERSIBLE: 'This actions not reversible.',
  THIS_QUOTE_WILL_REMAIN_ACTIVE_FOR: 'This quote will remain active for',
  THIS_USER: 'this user',
  TIMEZONE_ALASKA_STANDARD_TIME: 'Alaska Standard Time - AKST',
  TIMEZONE_ARGENTINA_TIME: 'Argentina Time - ART',
  TIMEZONE_BOLIVIA_TIME: 'Bolivia Time - BOT',
  TIMEZONE_BRAZIL_TIME: 'Brasília Time - BRT',
  TIMEZONE_CENTRAL_EUROPEAN_TIME: 'Central European Time - CET',
  TIMEZONE_CENTRAL_STANDARD_TIME: 'Central Standard Time - CST',
  TIMEZONE_CHILE_TIME: 'Chile Standard Time - CLT',
  TIMEZONE_COLOMBIA_TIME: 'Colombia Time - COT',
  TIMEZONE_EASTERN_EUROPEAN_TIME: 'Eastern European Time - EET',
  TIMEZONE_EASTERN_STANDARD_TIME: 'Eastern Standard Time - EST',
  TIMEZONE_ECUADOR_TIME: 'Ecuador Time - ECT',
  TIMEZONE_GREENWICH_MEAN_TIME: 'Greenwich Mean Time - GMT',
  TIMEZONE_GUYANA_TIME: 'Guyana Time - GYT',
  TIMEZONE_HAWAII_STANDARD_TIME: 'Hawaii Standard Time - HST',
  TIMEZONE_MOSCOW_TIME: 'Moscow Time - MSK',
  TIMEZONE_MOUNTAIN_STANDARD_TIME: 'Mountain Standard Time - MST',
  TIMEZONE_PACIFIC_STANDARD_TIME: 'Pacific Standard Time - PST',
  TIMEZONE_PARAGUAY_TIME: 'Paraguay Time - PYT',
  TIMEZONE_PERU_TIME: 'Peru Time - PET',
  TIMEZONE_SURINAME_TIME: 'Suriname Time - SRT',
  TIMEZONE_URUGUAY_TIME: 'Uruguay Time - UYT',
  TIMEZONE_VENEZUELA_TIME: 'Venezuela Time - VET',
  TIMEZONE_WESTERN_EUROPEAN_TIME: 'Western European Time - WET',
  TIME_ZONE: 'Time zone',
  TO: 'To',
  TOO_SHORT: 'Password too short, must have a minimum of 8 characters',
  TOTAL_AMOUNT: 'Total amount',
  TOTAL_FEES: 'Total fees',
  TOTP_APP_FREEOTP_NAME: 'FreeOTP',
  TOTP_APP_GOOGLE_NAME: 'Google Authenticator',
  TOTP_APP_MICROSOFT_AUTHENTICATOR_NAME: 'Microsoft Authenticator',
  TOTP_DISABLED_ERROR: 'An error occurred while disabling two-factor authentication',
  TOTP_DISABLED_SUCCESS: 'Two-factor authentication disabled successfully',
  TOTP_ENABLED_FAILED: 'An error occurred while enabling two-factor authentication',
  TOTP_ENABLED_SUCCESS: 'Two-factor authentication enabled successfully',
  TOTP_STEP_1: 'Open an authenticator app such as Google Authenticator or FreeOTP',
  TOTP_STEP_2: 'Scan the QR code using the authenticator app',
  TOTP_STEP_3: 'Enter the temporary code generated with your authenticator app',
  TO_DATE: 'To ({0})',
  TO_DATE_CANNOT_BE_AFTER_TODAY: 'End date cannot be after today',
  TO_DATE_MUST_BE_AFTER_FROM_DATE: 'End date must be after the start date',
  TRANSACTION_CONFIRMATION: 'Transaction confirmation',
  TRANSACTION_DETAILS: 'Transaction details',
  TRANSACTION_DETAILS_TITLE: 'Transaction details',
  TRANSACTION_HASH: 'Transaction hash',
  TRANSACTION_ID: 'Transaction ID#',
  TRANSACTION_NOT_FOUND: 'Transaction not found',
  TRANSACTION_TYPE: 'Transaction type',
  TRANSACTION_UETR: 'Transaction ID# (UETR)',
  TRANSFER: 'Transfer',
  TRANSFER_CREATED_DESCRIPTION: 'Get notified when a transfer has been created',
  TRANSFER_CREATED_LABEL: 'Created',
  TRANSFER_FEES_FREE: 'Transfer fees (Free)',
  TRANSFER_FEES_WITH_PERCENTAGE: 'Transfer fees ({0})',
  TRANSFER_FUNDS: 'Transfer funds',
  TRANSFER_RECEIVED: "We've received your payment and initiated your transfer",
  TRANSFER_STATUS: 'Transfer status',
  TRANSFER_TO: 'Transfer to {0}',
  TREASURY_MANAGEMENT: 'Treasury Management',
  TREASURY_MANAGEMENT_DESC: 'Optimize international treasury operations and cash balances',
  TRY_CHANGING_YOUR_APPLIED_FILTERS: `Try changing your applied filters to see more {0}.`,
  TWO_FACTOR_AUTHENTICATION: 'Scan the QR code to get your temporary code',
  TWO_FACTOR_AUTHENTICATION_DESCRIPTION:
    'We encourage you to set up an authenticator app to best protect your account',
  TWO_FACTOR_AUTHENTICATION_SECTION_DESCRIPTION:
    'Prevent unauthorized access to your Caliza account by setting up two-factor authentication with an authenticator app',
  TWO_FACTOR_AUTHENTICATION_SECTION_LABEL: 'Two-factor authentication',
  TWO_FACTOR_AUTHENTICATION_SETUP: 'Set up two-factor authentication',
  TWO_FACTOR_AUTHENTICATION_SETUP_DESCRIPTION:
    'Scan this QR code with your authenticator app to set up two-factor authentication.',
  TWO_FACTOR_AUTHENTICATION_SETUP_SECRET: 'Or enter this secret key manually',
  TWO_FACTOR_DISABLED_ERROR: 'Failed to disable two-factor authentication. Please try again.',
  TWO_FACTOR_DISABLED_SUCCESS: 'Two-factor authentication has been disabled successfully.',
  TWO_FACTOR_RESET_ERROR: 'Failed to reset two-factor authentication. Please try again.',
  TWO_FACTOR_RESET_SUCCESS:
    'Two-factor authentication has been reset successfully. You will be logged out shortly.',
  TYPE: 'Type',
  UNKNOWN: 'Unknown',
  UNKNOWN_ERROR: 'Unknown error',
  UNSET: '(Unset)',
  UPDATE: 'Update',
  UPDATE_ACCOUNT_INFORMATION: 'Update account information',
  UPDATE_CONTACT_SUCCESS: 'Contact updated successfully',
  UPDATE_EMAIL_ADDRESS_DESCRIPTION:
    'Confirmation when you update your email address for your account',
  UPDATE_EMAIL_ADDRESS_LABEL: 'Updated email address',
  UPDATE_PAYMENT_METHOD_SUCCESS: 'Payment method updated successfully',
  UPLOAD_DOCUMENT: 'Upload document',
  USDC_AND_USDT: 'USDC and USDT on & off ramps for businesses of all sizes',
  USDC_LABEL: 'USDC',
  USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY: 'USD (ACH and Wires)',
  USER: 'user',
  USERS: 'users',
  USE_KEY: 'Use key',
  USE_YOUR_CALIZA_BALANCE: 'Use your Caliza balance',
  US_DOLLAR: 'US Dollar',
  VALIDATION_ACTIVE_USER_CONFLICT: 'This email address is already linked to an active user',
  VALIDATION_CVU_INVALID: 'CVU or CBU must be exactly 22 digits',
  VALIDATION_INVALID_SWIFT_CHARACTERS:
    "{0} contains invalid characters. Only alphanumeric characters, spaces, and the following symbols are allowed: / - ? : ( ) . , ' +",
  VALIDATION_PASSWORD_MIN_8: 'Password must have a minimum of 8 characters',
  VALIDATION_PASSWORD_NUMBER: 'Password must have a minimum of 1 number',
  VALIDATION_PASSWORD_SPECIAL_CHARACTER: 'Password must have a minimum of 1 special character',
  VALIDATION_REQUIRED: '{0} is required',
  VALIDATION_TOO_LONG_16: '{0} must be less than 16 characters',
  VALIDATION_TOO_LONG_20: '{0} must be less than 20 characters',
  VALIDATION_TOO_LONG_70: '{0} must be less than 70 characters',
  VALIDATION_USER_CONFLICT: 'An invite was already sent to this email to join your team',
  VERIFICATION_STATUS: 'Verification status',
  VERIFY: 'Verify',
  VERIFY_BUSINESS_ADDRESS: 'Address',
  VERIFY_BUSINESS_ADDRESS_LABEL: 'Address',
  VERIFY_BUSINESS_ADD_ANOTHER_OWNER: 'Add another owner',
  VERIFY_BUSINESS_ADD_SOCIAL_MEDIA: 'Add another social media channel',
  VERIFY_BUSINESS_ANNUAL_INCOME: 'Annual income',
  VERIFY_BUSINESS_BANK_STATEMENT: 'Bank account statement',
  VERIFY_BUSINESS_BANNER: 'Verify your business to send your first payment',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_DESC:
    'A beneficial owner is any individual who directly or indirectly owns 25% or more of your company.',
  VERIFY_BUSINESS_BENEFICIAL_OWNERS_TITLE: 'Beneficial owners',
  VERIFY_BUSINESS_BENEFICIAL_OWNER_ADDRESS_QUESTION: "What is the beneficial owner's address?",
  VERIFY_BUSINESS_BENEFICIAL_OWNER_COUNTER: 'Beneficial owner #{0}',
  VERIFY_BUSINESS_BUSINESS_CONTACT_DESC:
    'The business representative is the primary point of contact who will manage the business relationship and ongoing operations with Caliza.',
  VERIFY_BUSINESS_BUSINESS_CONTACT_TITLE: 'Business contact',
  VERIFY_BUSINESS_CITY: 'City',
  VERIFY_BUSINESS_CNPJ: 'CNPJ',
  VERIFY_BUSINESS_CNPJ_FORMAT: 'CNPJ must follow this format: 12.345.678/9012-34',
  VERIFY_BUSINESS_CNPJ_QUESTION: 'What is the CNPJ?',
  VERIFY_BUSINESS_CNPJ_REGISTRATION: 'CNPJ registration',
  VERIFY_BUSINESS_COMMERCIAL_NAME: 'Commercial business name',
  VERIFY_BUSINESS_COMMERCIAL_NAME_QUESTION: "What is the company's commercial business name?",
  // New hardcoded strings that need translation
  VERIFY_BUSINESS_COMPANY_DETAILS_TITLE: 'Company details',
  VERIFY_BUSINESS_COMPANY_PROFILE_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_COMPANY_PROFILE_TITLE: 'Company profile',
  VERIFY_BUSINESS_CONTACT_INFORMATION: 'Contact information',
  VERIFY_BUSINESS_CONTACT_INFORMATION_QUESTION: 'What is their contact information?',
  VERIFY_BUSINESS_CONTACT_LABEL: 'Contact',
  VERIFY_BUSINESS_CONTACT_QUESTION: 'Who is the point of contact for the business?',
  VERIFY_BUSINESS_COUNTRIES: 'Countries',
  VERIFY_BUSINESS_CUSTOMER_COUNTRIES_QUESTION: 'What countries are your customers located in?',
  VERIFY_BUSINESS_CUSTOMER_DESCRIPTION: 'A description of your customer',
  VERIFY_BUSINESS_CUSTOMER_INDUSTRIES_QUESTION:
    'Which industries do you have customers in? Select all that apply',
  VERIFY_BUSINESS_CUSTOMER_QUANTITY_QUESTION: 'How many approximate customers do you have?',
  VERIFY_BUSINESS_CUSTOMER_TYPE_QUESTION:
    'What type of customers do you have? Select all that apply',
  VERIFY_BUSINESS_DOCUMENTS: 'Documents',
  VERIFY_BUSINESS_DOCUMENTS_DESCRIPTION:
    'Please upload the company documents below. We support PDF, JPG, JPEG, PNG, and Word formats of a maximum size of [20] MB',
  VERIFY_BUSINESS_DOCUMENTS_TITLE: 'Documents',
  VERIFY_BUSINESS_EMAIL: 'Email',
  VERIFY_BUSINESS_EMAIL_QUESTION: 'What is their email?',
  VERIFY_BUSINESS_ENTITY_TYPE: 'Entity type',
  VERIFY_BUSINESS_ENTITY_TYPE_QUESTION: 'What is the entity type?',
  VERIFY_BUSINESS_EXPECTED_RANGE: 'Expected $ range',
  VERIFY_BUSINESS_FINANCIAL_INSTITUTION_QUESTION: 'Are you a payment or financial institution',
  VERIFY_BUSINESS_FIRST_NAME: 'First name',
  VERIFY_BUSINESS_INCORPORATION_DOCUMENT: 'Incorporation document or articles of incorporation',
  VERIFY_BUSINESS_INDUSTRY_QUESTION: 'What industry is your business in?',
  VERIFY_BUSINESS_LAST_NAME: 'Last name',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME: 'Legal entity name',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_HELP:
    'Legal entity name must exactly match "NOME EMPRESARIAL" in your company\'s "CADASTRO NACIONAL DA PESSOA JURÍDICA" document.',
  VERIFY_BUSINESS_LEGAL_ENTITY_NAME_QUESTION: 'What is the legal entity name?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_DESC:
    'A legal representative is an individual with legal authority and powers to represent your company.',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_LABEL: 'Legal representative',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_QUESTION:
    'Who is the legal representative of this business?',
  VERIFY_BUSINESS_LEGAL_REPRESENTATIVE_TITLE: 'Legal representative',
  VERIFY_BUSINESS_LICENSE_REQUIRED:
    'Are you required to have a license to operate in Brazil or another jurisdiction?',
  VERIFY_BUSINESS_MAIN_ADDRESS_QUESTION: "What is the company's main business address?",
  VERIFY_BUSINESS_MAIN_INDUSTRY: 'Main industry',
  VERIFY_BUSINESS_NATIONALITY: 'Nationality',
  VERIFY_BUSINESS_NUMBER_OF_CUSTOMERS: 'Number of customers',
  VERIFY_BUSINESS_OCCUPATION: 'Occupation',
  VERIFY_BUSINESS_ONLINE_PRESENCE_DESC:
    'Please share any other websites or online channels that could help us to better understand your business. These include social media accounts, e-commerce stores, and app store links.',
  // Additional tr() arguments that need symbols
  VERIFY_BUSINESS_ONLINE_PRESENCE_TITLE: 'Online presence',
  VERIFY_BUSINESS_OPERATIONS_TITLE: 'Business operations',
  VERIFY_BUSINESS_OPERATION_COUNTRIES_QUESTION: 'Which countries do you operate in?',
  VERIFY_BUSINESS_OPERATION_STARTED: 'Operation started',
  VERIFY_BUSINESS_OPERATION_START_QUESTION: 'When did the company start operations?',
  VERIFY_BUSINESS_ORGANIZATION_TITLE: 'Organization',
  VERIFY_BUSINESS_OWNER: 'Owner',
  VERIFY_BUSINESS_PERCENTAGE_OWNERSHIP: 'Percentage ownership',
  VERIFY_BUSINESS_PHONE: 'Phone',
  VERIFY_BUSINESS_PHONE_NUMBER: 'Phone number',
  VERIFY_BUSINESS_PHONE_QUESTION: 'What is their phone number?',
  VERIFY_BUSINESS_POSITION: 'Position',
  VERIFY_BUSINESS_POSITION_QUESTION: 'What is their position?',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY: 'Power of attorney',
  VERIFY_BUSINESS_POWER_OF_ATTORNEY_HELP:
    'Please provide a standing general Power of Attorney or a limited Power of Attorney that assigns authority to open accounts and sign contracts on behalf of the business',
  VERIFY_BUSINESS_SERVICES_DESCRIPTION: 'Description of products and services (Min 8 words)',
  VERIFY_BUSINESS_SERVICES_QUESTION: 'What products or services does your business offer?',
  VERIFY_BUSINESS_SOCIAL_MEDIA_QUESTION: 'What are your social media channels? (Optional)',
  VERIFY_BUSINESS_SOLE_PROPRIETOR_SKIP:
    'This section is not required since you are a sole proprietorship',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS: 'Source of funds',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_SOURCE_OF_FUNDS_TITLE: 'Source of funds',
  VERIFY_BUSINESS_SOURCE_OF_WEALTH: 'Source of wealth',
  VERIFY_BUSINESS_STATE: 'State',
  VERIFY_BUSINESS_SUITE_FLOOR_APT: 'Suite / Floor / Apt',
  VERIFY_BUSINESS_SUPPORTED_ID_DOCS: 'Supported ID docs (Passport, DL or Registro Geral)',
  VERIFY_BUSINESS_TAX_ID: 'Tax ID',
  VERIFY_BUSINESS_THIRD_PARTY_QUESTION:
    'Do you intend to use Caliza to move funds on behalf of customers or other third parties?',
  VERIFY_BUSINESS_TITLE: 'Business information',
  VERIFY_BUSINESS_TYPICAL_CUSTOMER_QUESTION: 'Please describe your typical customer',
  VERIFY_BUSINESS_UPLOAD_ID: 'Upload Passport, DL or Registro Geral',
  VERIFY_BUSINESS_URL: 'URL',
  VERIFY_BUSINESS_USD_VOLUME_QUESTION:
    'What is the expected monthly $USD volume you will move using Caliza?',
  VERIFY_BUSINESS_WEBSITE_LINK: 'Website link',
  VERIFY_BUSINESS_WEBSITE_QUESTION: 'What is your business website?',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_DESC:
    'Caliza requires additional information on your business, customers, and operations to better understand your needs and comply with regulations.',
  VERIFY_BUSINESS_YOUR_CUSTOMERS_TITLE: 'Your customers',
  VERIFY_BUSINESS_ZIP: 'Zip',
  VERIFY_YOUR_BUSINESS: 'Verify your business',
  VET: 'Total Effective Value',
  VET_TOOLTIP:
    'VET represents the implied all-in rate, considering spread, other fees, and applicable taxes',
  VIEWER: 'Viewer',
  VIEWER_DESCRIPTION:
    'Read‑only access to company accounts, view and download transaction history and activity reports',
  VIEW_ACTIVITY: 'View and download transaction history and activity reports',
  VIEW_AND_DOWNLOAD_TRANSACTIONS: 'View and download transaction history and activity report',
  WALLET: 'Wallet',
  WALLET_ADDRESS_COPIED: 'Address copied successfully',
  WALLET_BALANCE: 'Wallet balance ${0} Digital dollars',
  WALLET_INFORMATION: 'Wallet information',
  WALLET_INFORMATION_WITH_CURRENCY: 'Wallet information ({0})',
  WELCOME_BACK: 'Welcome back',
  WELCOME_TITLE: 'Welcome back, {0}',
  WE_ARE_DEPOSITING_YOUR_FUNDS: 'We are depositing your funds',
  WE_DONT_SUPPORT_YOUR_COUNTRY_YET: 'We don’t support your country yet',
  WE_RECEIVED_PAYMENT_INITIATED: "We've received your payment and initiated your transfer",
  WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION:
    'Check your history to track the status of the transfer. Transaction details can take a few minutes before they appear.',
  WHERE_SENDING_FUNDS: 'Where are you sending funds?',
  WIRE: 'Wire',
  WITHDRAW: 'Withdraw',
  WITHDRAWAL: 'Withdrawal',
  WITHDRAWAL_ACCOUNT: 'Withdrawal account',
  WITHDRAWAL_TO: 'Withdrawal to {0}',
  WITHDRAW_FUNDS: 'Withdraw funds',
  YEAR: 'Year',
  YES: 'Yes',
  YOU: 'You',
  YOURE_ALMOST_DONE: "You're almost done!",
  YOUR_ACCOUNT: 'Your account',
  YOUR_ACCOUNTS: 'Your accounts',
  YOUR_CALIZA_PASSWORD: 'Your Caliza password',
  YOUR_FUNDS_HAVE_BEEN_ADDED: 'Your funds have been added',
  YOUR_FUNDS_HAVE_BEEN_SENT: 'Your funds have been sent',
  YOU_DO_NOT_HAVE_ENOUGH_FUNDS: 'You do not have enough enough funds to complete this transaction',
  YOU_RECEIVE: 'You receive',
  YOU_SEND: 'You send',
  YOU_STILL_BE_ABLE_TO_EXPLORE_PRODUCT_DESCRIPTION:
    'You will still be able to explore our products, but not send any payments. We will notify you once we are active in your country.',
  YOU_WITHDRAW: 'You withdraw',
  ZERO_RESULTS_FOUND: '0 results found',
  ZIP: 'Zip',
};
export default strings;
